import React, { useState, useEffect } from 'react'
import { Box } from '@mui/system';
import { socket } from '../../../config/SocketApi';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import SignalCellularAlt1BarIcon from '@mui/icons-material/SignalCellularAlt1Bar';
import SignalCellularAlt2BarIcon from '@mui/icons-material/SignalCellularAlt2Bar';
const InternetSpeedTester = () => {
    const [downloadSpeed, setDownloadSpeed] = useState(0);
    useEffect(() => {
        const dataSize = 5000;
        const intervalDuration = 5000;

        let interval = setInterval(() => {
            const data = new Uint8Array(dataSize);
            data.fill('X'.charCodeAt(0));
            socket.emit('upload-data', data);
        }, intervalDuration);
        socket.on('speed-test', (data, serverDownloadStartTime) => {
            const downloadEndTime = new Date(new Date().toISOString()).getTime();
            const downloadDuration = (downloadEndTime - serverDownloadStartTime) / 1000;
            const downloadSpeedKbps = (dataSize / (downloadDuration * 0.2)) / 1024;
            setDownloadSpeed(Math.ceil(downloadSpeedKbps));
        });
        socket.on("disconnect", () => {
            setDownloadSpeed(0)
        })
        return () => {
            socket.off('disconnect')
            socket.off('speed-test')
            if (interval) clearInterval(interval);
        };
    }, []);

    return (
        <Box>
            {downloadSpeed > 800 && <SignalCellularAltIcon style={{ color: '#2ecc71' }} />}
            {downloadSpeed < 800 && downloadSpeed > 256 && <SignalCellularAlt2BarIcon style={{ color: '#e67e22' }} />}
            {downloadSpeed < 256 && <SignalCellularAlt1BarIcon style={{ color: '#e74c3c' }} />}
        </Box>
    )
}

export default InternetSpeedTester